import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { DamagedState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/damaged";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DamagedDetails = memo(function DamagedDetails({
  disabled,
}: ConditionTypeDetailsProps<DamagedState>) {
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Condition
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Applies when at least one item in the return is submitted as damaged.
      </Text>
    </Flex>
  );
});
